import { ApiConfig, APIURL } from '../../Config.js';
import axios from 'axios';
import querystring from 'querystring';


var OauthCtrl = (fn, er, oam_code) => {

    var config = {
        headers: {
            'X-OAUTH-IDENTITY-DOMAIN-NAME': 'AmexIdentityDomain',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    var data = {
        code: oam_code,//url della response di Login,
        redirect_uri: APIURL+'/login',
        grant_type: "authorization_code",
        client_id: 'AmexClient'
    }

    axios
        .post(ApiConfig.url.OAUTH, querystring.stringify(data), config)
        .then(function (result) {
            //console.log(result.status);
            fn(result.data)
        })
        .catch(error => {
            er(error !== undefined && error.response !== undefined ? error.response : 500,
               error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
        });

}

export { OauthCtrl }

